import { useEffect } from 'react';
/** Use one native auto-layout calculation for all standalone hotel rows. */
export function useGagraHotelColumns(services) {
    useEffect(() => {
        const root = document.querySelector('.gpo-body #cart-section');
        if (!root)
            return;
        let frame = 0;
        let disposed = false;
        const update = () => {
            var _a;
            const tables = Array.from(root.querySelectorAll('.hotel-order-table'));
            if (!tables.length)
                return;
            const availableWidth = Math.min(...tables.map(table => table.parentElement.clientWidth));
            if (!availableWidth)
                return;
            // Measure only headers and service data, excluding forms and colspan rows.
            // The browser balances room/meal wrapping against the other columns.
            const host = document.createElement('div');
            host.className = 'cart';
            host.setAttribute('aria-hidden', 'true');
            host.style.cssText = `position:fixed;left:-100000px;top:0;visibility:hidden;pointer-events:none;width:${availableWidth}px`;
            const probe = document.createElement('table');
            probe.className = 'table order-table hotel-order-table';
            const header = (_a = tables.find(table => table.tHead)) === null || _a === void 0 ? void 0 : _a.tHead;
            if (header)
                probe.appendChild(header.cloneNode(true));
            const body = probe.createTBody();
            tables.forEach(table => {
                const row = table.querySelector('tbody > .order-info');
                if (row)
                    body.appendChild(row.cloneNode(true));
            });
            probe.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
            host.appendChild(probe);
            document.body.appendChild(host);
            try {
                const row = body.rows[0];
                if (!row || row.cells.length !== 8)
                    return;
                const widths = Array.from(row.cells).map(cell => cell.getBoundingClientRect().width);
                const tableWidth = probe.getBoundingClientRect().width;
                tables.forEach(table => {
                    widths.forEach((width, index) => table.style.setProperty(`--gagra-hotel-column-${index + 1}`, `${width}px`));
                    table.style.setProperty('--gagra-hotel-table-width', `${tableWidth}px`);
                    table.classList.add('gagra-hotel-columns-ready');
                });
            }
            finally {
                host.remove();
            }
        };
        const schedule = () => {
            if (disposed)
                return;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(update);
        };
        const observer = new ResizeObserver(schedule);
        observer.observe(root);
        window.addEventListener('resize', schedule);
        document.fonts.ready.then(schedule);
        schedule();
        return () => {
            disposed = true;
            cancelAnimationFrame(frame);
            observer.disconnect();
            window.removeEventListener('resize', schedule);
        };
    }, [services]);
}
